module.exports = __webpack_public_path__ + "static/media/group-chat-grey-icon.46082016.svg";